const DROPDOWN_VERTICAL_OFFSET = 84;

export const getDropdownPosition = (
    isOpen,
    selectRef,
    offset = DROPDOWN_VERTICAL_OFFSET
) => {
    if (isOpen && selectRef.current) {
        const rect = selectRef.current.getBoundingClientRect();
        return () => ({
            top: rect.bottom + window.scrollY - offset,
            left: rect.left + window.scrollX,
            width: rect.width,
            display: 'block'
        });
    }

    return (pos) => ({ ...pos, display: 'none' });
};

export const getSelectedComp = (providerId, showCompLogo) => {
    if (providerId && showCompLogo) {
        return PULSE.app.common.competition.getComp(providerId);
    }

    return null;
};
